<app-groups-renderer
  [groups]="groups()"
  [loadingGroups]="loadingGroups()"
  [isLoading]="isLoading()"
  [isDisabled]="disabled()"
  (componentAction)="onAction($event)"
/>
